<template>
  <div class="login">
    <!-- 底部 -->
    <div class="footer">
      <div class="footer-a">
        友情链接：
        <a v-for="(item,index) in list.links" :key="index" :href="item.url" target="_blank">{{item.name}}</a>
      </div>
      <div class="footer-bot">
        <div class="footer-bots">
          <div>
            <img class="footer-ewm" :src="list.qrcode[1]" alt="" />
            <div style="font-size: 16px; text-align: center">{{list.qrcode[0]}}</div>
          </div>
          <div style="font-size: 14px; color: #999;line-height:25px">
            <h2>关于我们</h2>
            <p>公司地址：{{list.contactinformation[2]}}</p>
            <p>服务电话：{{list.contactinformation[0]}}</p>
            <p>邮箱：{{list.contactinformation[1]}}</p>
            <p>{{list.contactinformation[3]}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      list:{
        contactinformation:[],
        links:[],
        qrcode:[],
      }
    };
  },
  components: {
  },
  mounted() {
    this.$apis
      .getcommoninfo()
      .then((res) => {
       this.list = res.data
      });
  },
  methods: {
    page(e) {
      this.$router.push({
        name: e,
        query: {
          id: 1,
        },
      });
    },
  },
};
</script>
<style scoped='scoped'>
img {
  width: 100%;
  height: 100%;
}
h2 {
  font-size: 18px;
  color: #000;
}
/* 底部 */
.footer {
  width: 100%;
  background-color: #fff;
  padding: 16px 0;
}
.footer-a {
  font-size: 14px;
  color: #707070;
  width: 50%;
  margin: 0 auto;
}
.footer-a a {
  margin-left: 16px;
}
.footer-bot {
  width: 50%;
  margin: 39px auto;
}
.footer-bots {
  display: flex;
  justify-content: space-between;
}
/* 二维码 */
.footer-ewm {
  width: 122px;
  height: 122px;
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .footer {
    width: 100%;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .footer-a,
  .footer-bot {
    width: 60%;
  }
}
@media only screen and (max-width: 767px) {
  .footer-a,
  .footer-bot {
    width: 90%;
  }
  .footer-ewm {
    width: 5rem;
    height: 5rem;
  }
}
</style>
